export const MOBILE_PROFILES = {
  FIELD_WORKER: 'field_worker',
  SALES: 'sales',
  NONE: 'none',
}

export function getMobileAppProfile(user) {
  const profile = user?.mobile_app_profile
  if (profile === 'sales' || profile === 'field_worker' || profile === 'none') {
    return profile
  }
  return Number(user?.role_id) === 1 ? MOBILE_PROFILES.NONE : MOBILE_PROFILES.FIELD_WORKER
}

/** Mobile web / native app ignores admin bypass — permissions only. */
export function hasMobilePermission(user, permissionCode) {
  if (!user) return false
  const permissions =
    user.permission_codes || user.permissions?.map((p) => p.code) || []
  return permissions.includes(permissionCode)
}

export function canAccessDefectSheetsMobile(user) {
  return (
    hasMobilePermission(user, 'defect_sheets') ||
    hasMobilePermission(user, 'defect_sheets_view')
  )
}

export function canEditDefectSheetsMobile(user) {
  return hasMobilePermission(user, 'defect_sheets')
}

export function canAccessQuotationsMobile(user) {
  return hasMobilePermission(user, 'quotations_view')
}

export function isSalesMobileProfile(user) {
  return getMobileAppProfile(user) === MOBILE_PROFILES.SALES
}

export function isFieldWorkerMobileProfile(user) {
  return getMobileAppProfile(user) === MOBILE_PROFILES.FIELD_WORKER
}

export function hasMobileAppAccess(user) {
  return getMobileAppProfile(user) !== MOBILE_PROFILES.NONE
}
